@if (visible()) {
  <button
    type="button"
    class="patient-pill"
    mat-button
    disableRipple
    [matMenuTriggerFor]="patientMenu"
    [attr.aria-label]="ariaLabel()"
    [attr.aria-haspopup]="'menu'">
    <mat-icon aria-hidden="true" class="patient-pill__icon">person</mat-icon>
    <span class="patient-pill__label">
      {{ pillLabel() ?? ('HEADER.PATIENT_PILL.LABEL' | translate) }}
    </span>
    <mat-icon aria-hidden="true" class="patient-pill__caret">expand_more</mat-icon>
  </button>

  <mat-menu #patientMenu="matMenu" xPosition="before">
    <div class="patient-pill__menu-title" role="presentation">
      {{ 'HEADER.PATIENT_PILL.MENU_TITLE' | translate }}
    </div>
    @for (patient of patients(); track trackByRettxid($index, patient)) {
      <button
        type="button"
        mat-menu-item
        (click)="onSelect(patient)"
        [attr.aria-current]="isActive(patient) ? 'true' : null">
        <mat-icon aria-hidden="true">
          {{ isActive(patient) ? 'check' : 'person_outline' }}
        </mat-icon>
        <span>{{ patient.given_name }} {{ patient.family_name }}</span>
      </button>
    }
  </mat-menu>
}
